import dynamic from 'next/dynamic';
import React, { Children } from 'react';

import { SectionsContainers } from './styles';
import { ScrollNavigationProps } from './types';

const ScrollNavigationHeader = dynamic(() => import('./scroll-navigation-header'), {
  ssr: false,
});

const ScrollNavigation = ({ children, isSticky, containerClassname }: ScrollNavigationProps) => {
  const linkItems = Children.map(children, (child) =>
    React.isValidElement<{ slug: string; tabText: string }>(child)
      ? { id: child.props.slug, linkText: child.props.tabText }
      : undefined,
  )!.filter((item) => item !== undefined);

  const shouldDisplayNavigation = linkItems.length > 1;
  return (
    <>
      {shouldDisplayNavigation && (
        <ScrollNavigationHeader items={linkItems} isSticky={isSticky} containerClassname={containerClassname} />
      )}
      <SectionsContainers className={containerClassname}>{children}</SectionsContainers>
    </>
  );
};

export default ScrollNavigation;
